<template>
  <div class="page-api-places">
    <div class="columns">
      <div class="column content">
        <div class="container">
          <p class="title">
            Google Places API.
          </p>
          <p class="subtitle" style="margin-bottom:30px;">
            Request for Google Places search &amp; Google Street View images.
          </p>
          <div class="control notification is-danger" v-if="error">
            <button class="delete" @click="error = undefined"></button>
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import auth from '@/apis/Auth'
export default {
  data () {
    return {
      error: undefined
    }
  },
  computed: mapGetters([
    'evenOrOdd',
    'isAuthenticated'
  ]),
  methods: {
    test () {
    },
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created ApiPlaces.vue')
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-api-places {
}
</style>



// WEBPACK FOOTER //
// ApiPlaces.vue?0f6bb14b